import { render } from "./expertrecommended.vue?vue&type=template&id=6900c3ad"
import script from "./expertrecommended.vue?vue&type=script&lang=js"
export * from "./expertrecommended.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__